import React, { useState, useEffect } from "react";

const SixthSection = () => {
  const [nameFocused, setNameFocused] = useState(false);
  const [emailFocused, setEmailFocused] = useState(false);
  const [messageFocused, setMessageFocused] = useState(false);

  const handleFocus = (field) => {
    if (field === "name") setNameFocused(true);
    if (field === "email") setEmailFocused(true);
    if (field === "message") setMessageFocused(true);
  };

  const handleBlur = (field) => {
    if (field === "name") setNameFocused(false);
    if (field === "email") setEmailFocused(false);
    if (field === "message") setMessageFocused(false);
  };

  const handleChange = (event) => {
    const { value, name } = event.target;
    if (value.trim() === "") {
      handleBlur(name);
    } else {
      handleFocus(name);
    }
  };

  useEffect(() => {}, []);

  return (
    <div className="sixthSection" id="contact">
      <div className="sixth-section-top">
        <span className="grey">Get in touch.</span>
        <h1>Contact Me</h1>
      </div>
      <div className="box">
        <div className="big-container">
          <div className="mid-container">
            <span className="grey">
              Please fill out the form to get in touch with me.
            </span>
          </div>

          <form
            id="simple-form"
            method="POST"
            action="https://formspree.io/f/xpzgzgyo"
          >
            {/* <div className={`inputBox ${nameFocused ? 'active' : ''}`}> */}
            <div className={`inputBox ${nameFocused ? "active" : ""}`}>
              <label htmlFor="name">Name:</label>
              <input
                // onFocus={() => handleFocus('name')}
                // onBlur={() => handleBlur('name')}
                type="text"
                id="name"
                name="name"
                onChange={handleChange}
              />
              <br />
            </div>
            {/* <div className={`inputBox ${emailFocused ? 'active' : ''}`}> */}
            <div className={`inputBox ${emailFocused ? "active" : ""}`}>
              <label htmlFor="email">Email:</label>
              <input
                // onFocus={() => handleFocus('email')}
                // onBlur={() => handleBlur('email')}
                type="email"
                id="email"
                name="email"
                onChange={handleChange}
              />
              <br />
            </div>
            {/* <div className={`inputBox ${messageFocused ? 'active' : ''}`}> */}
            <div className={`inputBox ${messageFocused ? "active" : ""}`}>
              <label htmlFor="message">Message:</label>
              <textarea
                // onFocus={() => handleFocus('message')}
                // onBlur={() => handleBlur('message')}
                rows="5"
                id="message"
                name="message"
                onChange={handleChange}
              ></textarea>
              <br />
            </div>
            <button className="submitButton" type="submit">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SixthSection;
